<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>抽奖</span>
				<el-button class="button" @click='edit("")' type="success">新增</el-button>
			</div>
			<div>
				<label>奖项:</label>
				<span style="color: red;" v-for="item in awards_list">{{item.awards}}({{item.num}}个,{{item.rand_num}}%),</span>
				<div>如果要调整数量或者概率,联系技术,直接修改表中值lottery_awards_num</div>
			</div>
		</template>
		<Search ref='searchProductConditions' @inputValue="inputSearch" />
		<el-table :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据"
		 v-loading="loading" :data="list.data" style="width: 100%;" border highlight-current-row>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
			<el-table-column prop="created_at" label="创建时间"></el-table-column>
			<el-table-column prop="customer_email" label="邮箱"></el-table-column>
			<el-table-column prop="lottery_url" label="前台链接"></el-table-column>
			<el-table-column label="客人抽奖时间">
				<template v-slot="scope">
					<span v-if="scope.row.lottery_time==0">暂未抽奖</span>
					<span v-else>{{scope.row.lottery_time}}</span>
				</template>
			</el-table-column>
			<el-table-column label="奖项" width="100">
				<template v-slot="scope">
					<span v-if="scope.row.awards==0">暂未抽奖</span>
					<span v-else>{{scope.row.awards}}</span>
				</template>
			</el-table-column>
			<el-table-column label="抽奖状态" width="100">
				<template v-slot="scope">
					<el-tag type="success" v-if="scope.row.status==1">已抽奖</el-tag>
					<el-tag type="danger" v-if="scope.row.status==0">未抽奖</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="奖品是否发送" width="100">
				<template v-slot="scope">
					<el-tag type="success" v-if="scope.row.send_status==1">已发送</el-tag>
					<el-button size="small" @click="send_status(scope.row.id)" type="danger" v-if="scope.row.send_status==0">未发送</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="shop_name" label="店铺名" width="100"></el-table-column>
			<el-table-column align="right" width="300">
					<template #header>
						<span>操作</span>
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="send_email(scope.row.customer_email,scope.row.lottery_url)">发送邮件</el-button>
						<el-button :disabled="scope.row.status==1" type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button type="danger" size="medium" @click="destroy(scope.row)">删除</el-button>
					</template>
				</el-table-column>
		</el-table>
		<pages :total="total" :page-size="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
	</el-card>
	<el-dialog :title='title' v-model="dialogFormVisible">
		<el-form label-position='left' :model="item" ref="form" :rules="rules" label-width="150px">
			<el-form-item label="邮箱" prop="customer_email">
				<el-input v-model="item.customer_email" size="small" placeholder="客人邮箱"></el-input>
			</el-form-item>
				<el-form-item label="站点" prop="shop_name">
				<el-input v-model="item.shop_name" size="small" placeholder="店铺名"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import pages  from'../common/Pagination.vue'
	import Search from '../common/Search.vue'
	export default {
		name: 'LotteryList',
		components: {
			pages,
			Search,
		},
		data() {
			return {
				dialogFormVisible: false,
				title: '新增',
				total: 0,
				currentPage: 1,
				pageSize: 10,
				loading: true,
				list: [],
				item: {
					customer_email:'',
					shop_name:''
				},
				awards_list:[],
				searchLotteryConditions: {
					customer_email:'',
				},
				rules: {
					customer_email: [{
						required: true,
						message: '请填写客人邮箱',
						trigger: 'blur'
					}],
					shop_name: [{
						required: true,
						message: '请填写店铺名',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			send_status(id){
				console.log(id)
				// this.loading = true;
				this.httpPost({
					url: '/admin/lottery/change_send_status',
					data: {id:id}
				}).then((re) => {
					if(re.code==1){
						this.$message.success(re.msg);
						this.getLotteryAwardsList();
						this.getLotteryList();
					}
				}).catch((err) => {})
			},
			send_email(email,lottery_url){
				// console.log(email)
				location= 'mailto:"'+email+'"?body="'+lottery_url+'"'
			},
			edit(row) {
				console.log(row)
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑';
					this.item = temp;
				} else {
					this.resetObj(this.item)
				}
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit(){
				console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						// console.log(this.item)
						// return false;
						this.loading = true
						this.dialogFormVisible = false

						this.httpPost({
							url: '/admin/lottery/lotteryUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.resetObj(this.item)
							this.loading = false
							this.getLotteryList()
						})
				
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			destroy(row) {
				console.log(row.id)
				let id = row.id
				// alert(id)
				// return false;
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/lottery/lotteryDel', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getLotteryList();
				})
			},
			handleSizeChangeFun(page){
				this.pageSize = page;
				this.getLotteryList();
			},
			handleCurrentChangeFun(page){
				this.currentPage = page;
				let str = '';
				str = this.$route.path+'?p='+page;
				this.$router.push(str);
				this.getLotteryList();
			},
			getLotteryAwardsList() {
				this.httpPost({
					url: '/admin/lottery/awards_list'
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.awards_list = temp;
			
				}).catch((err) => {})
			},
			getLotteryList(){
				console.log(this.searchLotteryConditions)
				let searchConditionsData = []
				if(this.searchLotteryConditions.customer_email!=''){
					searchConditionsData = this.searchLotteryConditions;
				}
				
				this.httpPost({
					url: '/admin/lottery/lotteryList',
					data:{p:this.currentPage,searchConditions:searchConditionsData,routePath: this.$route.path},
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.total = re.data.total;
					this.currentPage = re.data.currentPage;
					this.pageSize = re.data.pageSize
					this.loading = false;
							
				}).catch((err) => {})
			},
			inputSearch(inpVal) {
				console.log(inpVal)
				// this.loading = true;
				this.searchLotteryConditions.customer_email = inpVal.email
			
				this.loading = true;
				
				this.getLotteryList();
			},
		},
		created() {
			this.getLotteryAwardsList();
			this.getLotteryList();
		}
	}
</script>

<style>
</style>
